import styled from "styled-components";

const AboutUsStylesStylesContainer = styled.section`
    margin: -16px 0 30px;

    .page-banner {
        background-repeat: none;
        padding: 10px 0;
        @media (min-width: 768px) {
            padding: 30px 0;
        }
        @media (min-width: 992px) {
            padding: 80px 0;
        }
        .inner {
            padding: 35px 0;
            p {
                font-size: 30px;
                text-shadow: 5px 5px 15px rgb(0 0 0 / 50%);
                color: #fff;
                @media (min-width: 768px) {
                    font-size: 60px;
                }
            }
        }
    }

    .page-details {
        padding: 40px 0;

        .other-det {
            .item {
                width: 100%;
                @media (min-width: 768px) {
                    width: 50%;
                }
                &:first-child {
                    @media (min-width: 768px) {
                        padding-right: 15px;
                    }
                }
                &:last-child {
                    @media (min-width: 768px) {
                        padding-left: 15px;
                    }
                }
            }
        }

        .rt-sec {
            background: #f1f1f1;
            padding: 36px 30px;
            border-radius: 10px;
        }
    }
`;

const BreadcrumbsHeaderContainer = styled.div`
    padding-bottom: 20px;
    .heading {
        font-size: 25px;
        font-weight: 800;
        margin-bottom: 5px;
        text-transform: uppercase;
    }
    .link {
        color: #757575;
        transition: 0.2s;
        &:last-child {
            // pointer-events: none;
            font-weight: 600;
        }

        &:hover {
            color: #757575;
        }
    }

    .ec-breadcrumbs {
        color: #757575;
        font-size: 16px;
    }
`;

export { AboutUsStylesStylesContainer, BreadcrumbsHeaderContainer };
